package top.wcpe.allincore.ui.runtime.render.model

import kotlin.jvm.JvmName

/**
 * 渐变停止点：不可变值对象，由 offset（0-1）与 ARGB 颜色组成。
 *
 * ADR-0072 决策 1 镜像：真源为 `platform-client-api` 的
 * `top.wcpe.allincore.platform.client.api.render.command.GradientStop`
 * （纯 Java 8 对外 API，按 ADR-0002 不得 KMP 化）。equals/hashCode/toString 逐位复刻
 * Lombok `@Value` 语义（Float.compare 全序比较、PRIME=59、floatToIntBits），
 * 一致性由 jvmTest 的 RenderModelConsistencyTest 双向 roundtrip 守护。
 */
class GradientStop(@get:JvmName("offset") val offset: Float, @get:JvmName("argb") val argb: Int) {

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is GradientStop) return false
        // 复刻 Lombok Float.compare 全序比较（NaN 等于自身、区分 ±0）
        return offset.compareTo(other.offset) == 0 && argb == other.argb
    }

    // 逐位复刻 Lombok @Value：种子 1、59 倍累乘、float 用 floatToIntBits（Kotlin toBits）
    override fun hashCode(): Int = lombokHash(offset.toBits(), argb)

    override fun toString(): String = "GradientStop(offset=$offset, argb=$argb)"
}
